const initialState = {
  activeMenuLabel: "",
  dashboardHeader: null,
};

export const uiReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_ACTIVE_MENU_LABEL":
      return {
        ...state,
        activeMenuLabel: action.payload,
        dashboardHeader: null,
      };

    case "SET_DASHBOARD_HEADER":
      return {
        ...state,
        dashboardHeader: action.payload,
      };

    case "CLEAR_DASHBOARD_HEADER":
      return {
        ...state,
        dashboardHeader: null,
      };

    default:
      return state;
  }
};

export const setActiveMenuLabel = (label) => ({
  type: "SET_ACTIVE_MENU_LABEL",
  payload: label,
});

export const setDashboardHeader = (data) => ({
  type: "SET_DASHBOARD_HEADER",
  payload: data,
});

export const clearDashboardHeader = () => ({
  type: "CLEAR_DASHBOARD_HEADER",
});
